<template>
    <div id="app" v-show="isAuthorized">
        <Header />
        <div class="app-body">
            <main class="main">
                <div class="container-fluid">
                    <transition name="fade" mode="out-in">
                        <router-view />
                    </transition>
                </div>
            </main>
        </div>
        <Footer />
    </div>
</template>

<script>
import Header from './Header'
import Footer from './Footer'

export default {
    name: "BaseContainer",
    components: {
        Header, Footer
    },
    data() {
        return {
            isAuthorized: false
        }
    },
    methods: {

    },
    mounted: function() {
        
        // Call test api for authorization
        this.$axios.post("/auth/checkAuth").then(response => {

            let res = response.data

            if(res.message == "OK") {

                let appVersion = localStorage.getItem("appVersion")

                if(appVersion == null || appVersion != res.appVersion) {
                    localStorage.setItem("appVersion", res.appVersion)
                    window.location.reload()
                }
                else {
                    this.isAuthorized = true
                    this.$router.replace("/dashboard")
                }

            }   

        })

    }
}
</script>

<style scoped>

    #app {
        font-family: 'Open Sans', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        flex-direction: column;
        min-height: 100vh;
    }

    .main {
        -webkit-box-flex: 1;
        flex: 1;
        min-width: 0;
    }

    .app-body {
        flex-grow: 1;
        overflow-x: hidden;
        overflow-y: hidden;
        flex-direction: row;
        -webkit-box-flex: 1;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        background-color: #f3f3f3;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

</style>
